export const integrators_list = [
  { id: 1, name: 'EPS '},
  { id: 2, name: 'Mellon '}
]

export const integrators_ids = {
  eps: 1,
  mellon: 2
}